<template>
    <ValidationObserver ref="observer">
        <div>
            <b-card>
                <b-row class="my-4">
                    <b-col md="6">
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors, validate }"
                            name="Location"
                        >
                            <GmapAutocomplete
                                @change="validate"
                                @place_changed="placechange1"
                                class="mt-1 location-search"
                                :options="{
                                    fields: [
                                        'geometry',
                                        'formatted_address',
                                        'address_components',
                                    ],
                                }"
                            ></GmapAutocomplete>
                            <span class="validate-error custm-err">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col class="mt-1" md="6">
                        <c-input
                            type="text"
                            inputId="state"
                            readonly
                            v-model="office.address.state"
                            lableText="State"
                        />
                    </b-col>
                </b-row>
                <div class="streetmargintop">
                    <b-row class="mb-4">
                        <b-col md="6">
                            <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="City"
                            >
                                <c-input
                                    type="text"
                                    inputId="city"
                                    readonly
                                    v-model="office.address.city"
                                    lableText="City *"
                                />
                                <span class="validate-error custm-err">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="6">
                            <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="Country"
                            >
                                <c-input
                                    type="text"
                                    inputId="state"
                                    readonly
                                    v-model="office.address.country"
                                    lableText="Country *"
                                />
                                <span class="validate-error custm-err">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </b-col>
                        <b-col md="6" class="mt-3">
                            <ValidationProvider
                                rules="required|digits:6"
                                v-slot="{ errors }"
                                name="zipcode"
                            >
                                <c-input
                                    inputType="number"
                                    inputId="zipcode"
                                    v-model="office.address.zip"
                                    lableText="Zipcode *"
                                />
                                <span class="validate-error custm-err">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <slot name="footer-button" :data="office"> </slot>
                </div>
            </b-card>
        </div>
    </ValidationObserver>
</template>
<script>
import cInput from "@/components/Common/CustomInput";
import cTelInput from "@/components/Common/MobileNumberInput";
import csc from "country-state-city";
import ebSelect from "@/components/FormElements/Select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import locationMixins from "@/mixins/addressLocation";

export default {
    name: "AddressStepper",
    mixins: [locationMixins],
    data() {
        return {
            countries: [],
            states: [],
            cities: [],
            tenant: null,
            office: {
                address: {
                    country: "",
                    area: "",
                    state: "",
                    city: "",
                    street1: "",
                    street2: "",
                    zip: "",
                    houseNumber: "",
                    location: {
                        coordinates: [0, 0],
                    },
                },
            },
        };
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        cInput,
        cTelInput,
        ebSelect,
    },
    methods: {
        placechange1(e) {
            this.placechange(e);
            this.$emit("place_changed", e);
            let mapdata = this.$store.getters["item/GetCurrentCatalogLocation"];
            if (mapdata) {
                this.office.address.country = mapdata.data.Country;
                this.office.address.city = mapdata.data.City;
                this.office.address.state = mapdata.data.State;
                this.office.address.area = mapdata.data.Area
                    ? mapdata.data.Area
                    : "";
                this.office.address.zip = mapdata.data.zip
                    ? mapdata.data.zip
                    : "";
                this.office.address.location = {
                    coordinates: [mapdata.Lng, mapdata.Lat],
                };
            }
        },
        isValid() {
            const isValid = this.$refs.observer.validate();
            this.$emit("isValid", isValid);
            return isValid;
        },
        isValidate(e, p) {
            p.country = { ...e.country };
            p.isValid = e.isValid;
        },
        getCountry(payload) {
            this.setState(payload.id);
            this.office.address.country = payload.name;
        },
        getState(payload) {
            this.setCity(payload.id);
            this.office.address.state = payload.name;
        },
        getCity(payload) {
            this.office.address.city = payload.name;
        },
        async setCountry() {
            this.countries = await csc.getAllCountries();
        },
        async setState(id) {
            this.states = await csc.getStatesOfCountry(id);
        },
        async setCity(id) {
            this.cities = await csc.getCitiesOfState(id);
        },
    },
    mounted() {
        this.setCountry();
    },
};
</script>
<style scoped>
.location-search {
    border-radius: 0rem;
    color: rgb(0, 0, 0);
    box-shadow: none !important;
    font-family: "Lato";
    height: 39px !important;
    border: 1px solid #dee2e6;
    padding-left: 10px;
    width: 100%;
    font-size: small;
}
[btn-color="primary"] {
    height: 41px;
    background-color: var(--primary);
    font-weight: 600;
    font-size: medium;
    letter-spacing: 2px;
    font-family: "Lato";
    color: white;
    border: 0px;
    border-radius: 0px;
}

[btn-special="primary"] {
    border: 0px;
    font-weight: 500;
    letter-spacing: 1px;
    font-size: medium;
    font-family: "Lato";
    border-radius: 0px;
    height: 39px;
    width: 132px;
    background-color: var(--primary);
    color: white;
}
.statemargintop {
    margin-top: -15px !important;
}
.streetmargintop {
    margin-top: -8px !important;
}
</style>
<style>
.vue-tel-input {
    border-radius: 0px !important;
    height: 39px !important;
    border: 1px solid #dee2e6 !important;
}
.card {
    border-width: 1160px;
    border-radius: 16px;
}
.custm-err {
    color: red;
}
</style>
